export type SectionTone =
  | "cosmetic"
  | "medical"
  | "social"
  | "dental"
  | "exam"
  | "flag";

export const SECTION_TONES = [
  "cosmetic",
  "medical",
  "social",
  "dental",
  "exam",
  "flag",
] as const satisfies readonly SectionTone[];
